import {
  AB_ORDERS_REVAMP,
  HEADER_NAV_COLOUR,
  MAP_PICKER,
} from 'constants/experiments';
import PageTypes from 'constants/pageTypes';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { State } from 'shared/store/types';
import { getEligibleForVariant } from 'helpers/experimentV2';
import { getPageType } from 'components/Header/helper';
import { IS_MEN } from 'shared/helpers';
import { HELP_CENTER, NEED_HELP, MY_ORDERS } from 'constants/strings';
import { IN_HOUSE_HELP_CENTER_URLS } from 'constants/urls';
import { useConfigSwitch } from 'hooks/switch';
import { IS_IN_HOUSE_HELP_CENTER_ENABLED_SWITCH } from 'store/remoteConfig/constants';
import { MenuItemOverride, MenuItems } from 'types/Header';
import { getMenuItems } from 'helpers/utils/kebabMenu';
import {
  MY_ORDERS_PARAMS,
  ORDERS_LINK,
  ORDERS_REVAMP_LINK,
} from 'layouts/MyProfile/constants';

export const useIsThemeHeader = () => {
  const { pageTypes = [] } = useSelector(
    (state: State) => state?.remoteConfig.configs.themeHeader || {}
  );
  const { pathname } = useLocation();
  const isThemeHeader = useSelector((state: State) =>
    getEligibleForVariant(state, HEADER_NAV_COLOUR, 'A')
  );
  const currentPagetType = getPageType(pathname);

  return isThemeHeader && pageTypes.includes(currentPagetType);
};

export const useOrdersUrl = () => {
  const ordersRedirectionExpEnabled = useSelector((state: State) =>
    getEligibleForVariant(state, AB_ORDERS_REVAMP, 'A')
  );
  const ordersRevampUrl = useSelector(
    (state: State) =>
      state.remoteConfig.configs?.ordersRevampUrl ||
      `${ORDERS_REVAMP_LINK}?${MY_ORDERS_PARAMS.SRC_PARAM}`
  );

  if (ordersRedirectionExpEnabled) {
    return ordersRevampUrl;
  }
  return `${ORDERS_LINK}?${MY_ORDERS_PARAMS.PTYPE_PARAM}`;
};

export const useMenuItems = (): MenuItems => {
  const { beauty: BEAUTY_HELP_CENTER_URL } = IN_HOUSE_HELP_CENTER_URLS;
  const isInHouseHelpCenterEnabled = useConfigSwitch(
    IS_IN_HOUSE_HELP_CENTER_ENABLED_SWITCH
  );
  const ordersUrl = useOrdersUrl();

  const myOrdersRevampOverride = {
    [MY_ORDERS]: {
      link: ordersUrl,
      displayText: MY_ORDERS,
    },
  };

  const helpCenterOverride = {
    [HELP_CENTER]: {
      link: BEAUTY_HELP_CENTER_URL,
      displayText: HELP_CENTER,
    },
    [NEED_HELP]: {
      link: BEAUTY_HELP_CENTER_URL,
      displayText: HELP_CENTER,
    },
  };

  const overrides: MenuItemOverride = {
    ...(isInHouseHelpCenterEnabled && !IS_MEN && helpCenterOverride),
    ...myOrdersRevampOverride,
  };
  const menuItemsMap = getMenuItems(overrides);
  return menuItemsMap;
};
export const useMapPickerVariant = (): 'A' | 'B' | null =>
  useSelector((state: State) => {
    if (getEligibleForVariant(state, MAP_PICKER, 'A')) return 'A';
    if (getEligibleForVariant(state, MAP_PICKER, 'B')) return 'B';
    return null;
  });

export const useIsAddressBarEnabled = () => {
  const variant = useMapPickerVariant();
  const { pathname } = useLocation();
  const pageType = getPageType(pathname);
  return variant !== null && pageType === PageTypes.HOME;
};

export const useIsConfigHeader = () => {
  const headerAndFooterBgConfig = useSelector(
    (state: State) => state.remoteConfig.configs.headerAndFooterBgConfig
  );
  const { headerBg, footerBg, headerTextColor } = headerAndFooterBgConfig || {};
  return {
    headerBg,
    footerBg,
    headerTextColor,
  };
};
